import { AfterViewInit, Component, computed, inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { ToggleComponent } from "src/app/@core/components/ui/toggle/toggle.component";
import { Table, TableModule } from 'primeng/table';
import { CommonModule, TitleCasePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { AvatarModule } from "primeng/avatar";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { InputTextModule } from "primeng/inputtext";
import { SelectModule } from "primeng/select";
import { TooltipModule } from "primeng/tooltip";
import { lastValueFrom, Observable, Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { IconComponent, IconSourceEnum } from "src/app/@core/components/ui/icon/icon.component";
import { UserNameDisplayComponent } from "src/app/@shared/components/user-name-display";
import { environment } from "../../../../../environments/environment.dev";
import { ButtonComponent } from "../../../../@core/components/ui/button/button.component";
import { DeleteConfirmationComponent } from "../../../../@core/components/ui/delete-confirmation/delete-confirmation.component";
import { DialogComponent } from "../../../../@core/components/ui/dialog/dialog.component";
import { CustomMenuItem, MenuComponent } from "../../../../@core/components/ui/menu/menu.component";
import { SelectChangeEvent, SelectComponent, SelectConfig, SelectOption } from "../../../../@core/components/ui/select";
import { ADDITIONAL_ROLES, USER_ROLE } from "../../../../@core/models/enums";
import { hasBillingAccess } from "../../../../@core/utils/permissions.utils";
import { IInvitation, IRequestAccess, ISubscriptionDetails, IUser, IWorkspace, PAYMENT_MODE, REQUEST_TYPE, SHARE_ACCESS, USER_SOURCE } from "../../../../@core/models/model";
import { PhoneNumberDialogComponent } from "../../../../@shared/components/phone-number-dialog/phone-number-dialog.component";
import { AuthenticationService } from "../../../../@core/services/authentication.service";
import { SubscriptionStateService } from "../../../../@core/services/subscription-state.service";
import { ToastService } from "../../../../@core/services/toast.service";
import { DataTableComponent } from "../../../../@shared/components/data-table/data-table.component";
import { GridListViewComponent } from "../../../../@shared/components/grid-list-view/grid-list-view.component";
import { LottieAnimationComponent } from "../../../../@shared/components/lottie-animation/lottie-animation.component";
import { SearchBarComponent } from "../../../../@shared/components/search-bar/search-bar.component";
import { TransferOwnershipDialogComponent } from "../../../../@shared/components/transfer-ownership-dialog/transfer-ownership-dialog.component";
import { SORT_ORDER, TableColumn, TableConfig } from "../../../../@shared/models/table.models";
import { UserAvatarPipe } from "../../../../@shared/pipes/user-avatar-pipe";
import { BOB_IMAGES, CREDITS_SVG, SVG } from "../../../../common/svgs";
import { validateEmail } from "../../../../common/utils";
import { InvitationService } from "../../../services/invitation.service";
import { MicrosoftAzureService } from "../../../services/microsoft-azure.service";
import { OrganizationSetupFormService } from "../../../services/organization-setup-from.service";
import { REQUEST_VIEW, RequestAccessService } from "../../../services/request-access.service";
import { UserService } from "../../../services/user.service";
import { UserCreditsService } from "../../../../features/credits/services/user-credits.service";
import { UserCreditsStateService } from "../../../../features/credits/services/user-credits-state.service";
import { InputComponent } from "../../../../@core/components/ui/input/input.component";
import { PlanService } from "../../../../@core/services/plan.service";
import { EntityUnit, IPlan, TermUnit } from "../../../../pricing/models";
import { isDowngradePlan, termToCycleDays, termToMonthlyDivisor } from "../../../../pricing/plan-pricing.utils";
import { INVITES_TABLE_COLUMNS, INVITES_TABLE_CONFIG, PEOPLE_TABLE_COLUMNS, PEOPLE_TABLE_CONFIG, REQUESTS_TABLE_COLUMNS, REQUESTS_TABLE_CONFIG } from './people-table.config';
import { CheckoutItem, CreditsCheckoutDialogComponent } from "../../../../features/credits/components/credits-checkout-dialog/credits-checkout-dialog.component";
import { SelectButtonComponent } from "src/app/@core/components/ui/select-button/select-button.component";
import { FullNamePipe } from "../../../../@shared/pipes/fullName.pipe";
import { CheckoutConfig, CheckoutDialogComponent, CheckoutSource } from "src/app/pricing/checkout-dialog";
import { PaymentService } from "../../../services/payment.service";

export enum ADD_PEOPLE_METHOD {
    MANUAL = 'MANUAL',
    AZURE = 'AZURE'
}

@Component({
    selector: 'app-people',
    standalone: true,
    imports: [ButtonModule, TableModule, DialogComponent, FormsModule, SelectModule, ConfirmDialogModule, CommonModule, GridListViewComponent, SearchBarComponent, TitleCasePipe, UserAvatarPipe, FullNamePipe, AvatarModule, ButtonComponent, SelectComponent, DeleteConfirmationComponent, MenuComponent, CheckboxModule, InputTextModule, TooltipModule, DataTableComponent, IconComponent, LottieAnimationComponent, TransferOwnershipDialogComponent, CreditsCheckoutDialogComponent, UserNameDisplayComponent, ToggleComponent, SelectButtonComponent, CheckoutDialogComponent, PhoneNumberDialogComponent],
    templateUrl: './people.component.html',
    styleUrl: './people.component.scss',
})
export class PeopleComponent implements OnInit, AfterViewInit {

    activeUsersCount: number = 0;
    activeInvitesCount: number = 0;
    users: IUser[] = []
    allUsers: IUser[] = [] // Store all users for filtering
    currentUser: IUser;
    REQUEST_TYPE = REQUEST_TYPE;
    email = '';
    tab = 'people';
    invites: IInvitation[] = [];
    allInvites: IInvitation[] = [] // Store all invites for filtering
    requests: IRequestAccess[] = [];
    allRequests: IRequestAccess[] = [] // Store all requests for filtering
    historyRequests: IRequestAccess[] = [];
    allHistoryRequests: IRequestAccess[] = [];
    selectedRequests: IRequestAccess[] = [];
    REQUEST_VIEW = REQUEST_VIEW;
    requestView: REQUEST_VIEW = REQUEST_VIEW.CURRENT;
    requestViewOptions = [
        { value: REQUEST_VIEW.CURRENT, label: 'Incoming' },
        { value: REQUEST_VIEW.HISTORY, label: 'History' }
    ];
    private routerSubscription!: Subscription;
    private readonly titleCasePipe = new TitleCasePipe();

    searchValue: string = '';
    members: {
        email: string,
        role: USER_ROLE,
        planId?: string,
        planName?: string
    }[] = []
    userLoading: boolean = false
    inviteLoading: boolean = false
    rejectingDeactivation: boolean = false

    // Add People Menu
    addPeopleMenuItems: CustomMenuItem[] = [{
        label: 'Manual',
        icon: 'plus',
        iconSource: IconSourceEnum.LUCIDE,
        value: ADD_PEOPLE_METHOD.MANUAL
    }, {
        label: 'Azure',
        icon: SVG.AZURE,
        iconSource: IconSourceEnum.SVG,
        value: ADD_PEOPLE_METHOD.AZURE
    }];

    // Azure Dialog
    azureDialogVisible: boolean = false;
    azureSearchValue: string = '';
    azurePeopleList: any[] = [];
    selectedAzurePeople: any[] = [];
    selectAllAzure: boolean = false;
    isLoadingAzurePeople: boolean = false;
    searchAnimationData: any = null;
    azureNextLink: string | null = null;
    hasMoreAzureUsers: boolean = false;
    isLoadingMoreAzureUsers: boolean = false;
    isLoadingSelectAllAzure: boolean = false;
    private azureSearchSubject = new Subject<string>();
    private destroy$ = new Subject<void>();
    private selectedAzurePeopleMap: Map<string, any> = new Map();
    private subscriptionState = inject(SubscriptionStateService);



    BOB_IMAGES = BOB_IMAGES;
    CREDITS_SVG = CREDITS_SVG;
    ICON_SOURCE = IconSourceEnum;

    roleOptions: SelectOption[] = [
        { label: 'Organization Admin', value: USER_ROLE.ADMIN },
        { label: 'Organization Member', value: USER_ROLE.MEMBER }
    ];

    additionalRoleOptions: SelectOption[] = [
        { label: 'Billing Admin', value: ADDITIONAL_ROLES.BILLING_ADMIN },
    ]

    roleConfig: SelectConfig = {
        placeholder: 'Select Role',
        searchable: false,
        clearable: false,
        styleClass: 'w-full',
        appendTo: 'body'
    };

    roleConfigInline: SelectConfig = {
        placeholder: 'Select Role',
        searchable: false,
        clearable: false,
        styleClass: 'border w-32 rounded-lg',
        style: { 'width': '100%' },
        appendTo: 'body'
    };

    // Template References for data table
    @ViewChild('nameTemplateRef') nameTemplateRef!: TemplateRef<any>;
    @ViewChild('contactTemplateRef') contactTemplateRef!: TemplateRef<any>;
    @ViewChild('emailTemplateRef') emailTemplateRef!: TemplateRef<any>;
    @ViewChild('roleTemplateRef') roleTemplateRef!: TemplateRef<any>;
    @ViewChild('additionalRolesTemplateRef') additionalRolesTemplateRef!: TemplateRef<any>;
    @ViewChild('actionsTemplateRef') actionsTemplateRef!: TemplateRef<any>;
    @ViewChild('workspaceTemplateRef') workspaceTemplateRef!: TemplateRef<any>;
    @ViewChild('statusTemplateRef') statusTemplateRef!: TemplateRef<any>;
    @ViewChild('userTemplateRef') userTemplateRef!: TemplateRef<any>;
    @ViewChild('azureActionsTemplateRef') azureActionsTemplateRef!: TemplateRef<any>;
    @ViewChild('azureRoleTemplateRef') azureRoleTemplateRef!: TemplateRef<any>;
    @ViewChild('requestsActionBarTemplateRef') requestsActionBarTemplateRef!: TemplateRef<any>;
    @ViewChild('askModeTemplateRef') askModeTemplateRef!: TemplateRef<any>;
    @ViewChild('agentModeTemplateRef') agentModeTemplateRef!: TemplateRef<any>;
    @ViewChild('changePlanTemplateRef') changePlanTemplateRef!: TemplateRef<any>;
    @ViewChild('historyActionTemplateRef') historyActionTemplateRef!: TemplateRef<any>;
    @ViewChild('invitePaymentTemplateRef') invitePaymentTemplateRef!: TemplateRef<any>;

    @ViewChild('people') peopleTable!: Table;
    @ViewChild('invite') invitesTable!: Table;
    public inviteDialogVisible: boolean = false;
    public isAdmin = false;
    public hasBillingAccess = false;
    USER_ROLE = USER_ROLE

    // Delete confirmation dialogs
    deleteUserDialogVisible: boolean = false;
    deleteInviteDialogVisible: boolean = false;
    approveRequestDialogVisible: boolean = false;
    rejectRequestDialogVisible: boolean = false;
    transferOwnershipDialogVisible: boolean = false;
    selectedUserId: string = '';
    selectedInviteId: string = '';
    selectedRequestId: string = '';
    selectedRequest: IRequestAccess | null = null;
    selectedUserForDelete: IUser | null = null; // User being deleted (for transfer ownership)
    isDeleteUserTransfer: boolean = false; // Flag to track if transfer is for delete user

    // Transfer billing admin dialog (shown before deleting a billing admin user)
    transferBillingAdminDialogVisible: boolean = false;
    billingAdminTransferUsers: IUser[] = [];
    billingAdminTransferFilteredUsers: IUser[] = [];
    billingAdminTransferSearchQuery: string = '';
    selectedBillingAdminTransferUser: IUser | null = null;
    isTransferringBillingAdmin: boolean = false;
    private pendingDeleteAfterBillingTransfer: boolean = false;

    // Checkout dialog (credits approval)
    checkoutDialogVisible: boolean = false;
    checkoutItems: CheckoutItem[] = [];
    readonly checkoutSuccessUrl = '/settings/people/requests?session_id={CHECKOUT_SESSION_ID}&credit_type=TOP_UP&success=true';
    readonly checkoutCancelUrl = '/settings/people/requests';
    // Values come from /payment/org-users-plans as full subscription docs; approving a plan
    // change writes a bare plan name in-place, so both shapes are real.
    userPlanNames: Record<string, string | ISubscriptionDetails> = {};

    // Change Plan (checkout dialog)
    availablePlans: IPlan[] = [];
    isLoadingPlans: boolean = false;
    selectedChangePlanId: string = '';
    selectedUsers: IUser[] = [];
    selectedUsersForCheckout: IUser[] = [];
    bulkChangePlanUsers: IUser[] = [];

    // Approve Plan Change dialog
    approvePlanChangeDialogVisible: boolean = false;
    proratedCharge: number | null = null;
    isFetchingProratedCharge: boolean = false;
    isApprovingPlanChange: boolean = false;

    // Bulk operation dialogs
    bulkApproveCreationDialogVisible: boolean = false;
    bulkRejectCreationDialogVisible: boolean = false;
    bulkApproveDeactivationDialogVisible: boolean = false;
    bulkRejectDeactivationDialogVisible: boolean = false;
    bulkRejectCreditDialogVisible: boolean = false;
    bulkOperationType: 'creation' | 'deactivation' | null = null;
    bulkSelectedRequestIds: string[] = [];

    // Table Configuration
    usersTableColumns: TableColumn[] = [];
    invitesTableColumns: TableColumn[] = [];
    requestsTableColumns: TableColumn[] = [];
    requestsTableConfig: TableConfig = {
        ...REQUESTS_TABLE_CONFIG(),
        columnSortingFunction: (field: string, order: SORT_ORDER) => this.sortRequests(field, order),
    };

    showCheckoutDialog: boolean = false;
    showPhoneNumberDialog: boolean = false;
    pendingSalesPlanName: string = '';
    readonly userEntityType = EntityUnit.USER;
    CheckoutSource = CheckoutSource;

    get isSalesPaymentMode(): boolean {
        return this.subscriptionState.orgSubscriptionDetails()?.paymentMode === PAYMENT_MODE.SALES;
    }

    // Invite plan selection
    showInviteSingleCheckoutDialog: boolean = false;
    showInviteBulkCheckoutDialog: boolean = false;
    currentMemberForCheckoutIndex: number = -1;
    currentMemberEmails: string[] = [];
    bulkInviteEmails: string[] = [];
    bulkInviteMembers: Array<{ email: string, role?: string, planId?: string, planName?: string }> = [];

    getRequestsRowClass = (rowData: any, index: number): string => {
        return this.selectedRequests.some(selected => selected._id === rowData._id) ? 'bg-arena-orange-200' : '';
    };

    getTransferOwnershipUserCount(): number {
        // If this is for delete user, return 1
        if (this.isDeleteUserTransfer) {
            return 1;
        }
        // If bulk deactivation is being processed, return the count of selected deactivation requests
        if (this.bulkSelectedRequestIds.length > 0) {
            const deactivationCount = this.allRequests.filter(r =>
                this.bulkSelectedRequestIds.includes(r._id) &&
                r.requestType === REQUEST_TYPE.DEACTIVATION
            ).length;
            return deactivationCount > 0 ? deactivationCount : this.bulkSelectedRequestIds.length;
        }
        // For single request approval, return 1
        return 1;
    }

    /**
     * Check if default transfer should be disabled for delete user scenario
     * Disable if the user being deleted is SUPER_ADMIN (account owner)
     */
    get isDeleteUserTransferDisabled(): boolean {
        if (!this.isDeleteUserTransfer || !this.selectedUserForDelete) {
            return false;
        }
        return this.selectedUserForDelete.role === USER_ROLE.SUPER_ADMIN;
    }
    usersTableConfig: TableConfig = {
        ...PEOPLE_TABLE_CONFIG,
        selectable: true,
        columnSortingFunction: (field: string, order: SORT_ORDER) => this.sortUsers(field, order)
    };
    invitesTableConfig: TableConfig = {
        ...INVITES_TABLE_CONFIG,
        columnSortingFunction: (field: string, order: SORT_ORDER) => this.sortInvites(field, order)
    };

    // Azure People Table Configuration
    azurePeopleTableColumns: TableColumn[] = [];
    azurePeopleTableConfig: TableConfig = {
        paginator: false,
        loading: false,
        emptyMessage: 'No people selected',
        selectable: false
    };

    readonly isTrail = this.subscriptionState.orgIsTrial;
    maxUsersReachedDialogVisible: boolean = false;
    maxUsersAllowed: number = 0;

    constructor(private userService: UserService, private toast: ToastService, private invitationService: InvitationService, private requestAccessService: RequestAccessService, private router: Router, private route: ActivatedRoute, private authService: AuthenticationService, private organizationService: OrganizationSetupFormService, private http: HttpClient, private microsoftAzureService: MicrosoftAzureService, private userCreditsService: UserCreditsService, private userCreditsStateService: UserCreditsStateService, private planService: PlanService, private paymentService: PaymentService) {
        this.currentUser = this.authService.getUser() ?? {} as IUser;
        this.isAdmin = [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN].includes(this.currentUser.role);
        this.hasBillingAccess = hasBillingAccess(this.currentUser);
        this.requestsTableConfig = {
            ...REQUESTS_TABLE_CONFIG(false, this.hasBillingAccess),
            columnSortingFunction: (field: string, order: SORT_ORDER) => this.sortRequests(field, order),
        };
        this.usersTableColumns = [...PEOPLE_TABLE_COLUMNS(this.isAdmin, this.hasBillingAccess)];
        this.invitesTableColumns = [...INVITES_TABLE_COLUMNS(this.isAdmin)];
        this.requestsTableColumns = [...REQUESTS_TABLE_COLUMNS(this.isAdmin)];
        this.initializeAzureTableColumns();
        this.getUserRole();
        this.loadSearchAnimation();
        this.setupAzureSearchDebounce();

        const queryParams = this.route.snapshot.queryParams;
        const sessionId = queryParams['session_id'];
        const success = queryParams['success'];
        const creditType = queryParams['credit_type'];
        if (sessionId && success === 'true') {
            if (creditType === 'PLAN_CHANGE' || creditType === 'INVITE_USER_PAYMENT') {
                this.toast.success(creditType === 'PLAN_CHANGE'
                    ? 'Payment completed — plan change approved'
                    : 'Payment completed — invitations sent');
                this.router.navigate(['settings/people/requests']);
            } else {
                this.userCreditsService.checkCreditsAllocationStatus(sessionId).subscribe((res) => {
                    if (res?.data) {
                        this.toast.success('Payment completed successfully');
                        this.userCreditsStateService.refreshCredits().subscribe();
                        this.router.navigate(['settings/people/requests']);
                    }
                });
            }
        }
    }

    initializeAzureTableColumns() {
        this.azurePeopleTableColumns = [
            { field: 'rowIndex', header: 'S.No.', type: 'text', width: '8%' },
            { field: 'name', header: 'Name', type: 'text', width: '25%' },
            { field: 'email', header: 'Email ID', type: 'text', width: '25%' },
            { field: 'position', header: 'Position', type: 'text', width: '15%' },
            { field: 'role', header: 'Role', type: 'custom', template: 'azureRoleTemplate', width: '20%' },
            { field: 'actions', header: 'Actions', type: 'custom', template: 'azureActionsTemplate', width: '7%' }
        ];
    }

    getUserRole() {
        this.userService.getCurrentUser().subscribe((res) => {
            if (res.success) {
                this.currentUser = res.data;
                this.isAdmin = [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN].includes(this.currentUser.role);
                this.hasBillingAccess = hasBillingAccess(this.currentUser);
                this.usersTableColumns = [...PEOPLE_TABLE_COLUMNS(this.isAdmin, this.hasBillingAccess)];
                this.invitesTableColumns = [...INVITES_TABLE_COLUMNS(this.isAdmin)];
                this.requestsTableColumns = [...REQUESTS_TABLE_COLUMNS(this.isAdmin)];
            }
        })
    }

    async ngOnInit() {
        this.routerSubscription = this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd)
            )
            .subscribe(() => {
                this.checkRoute();
            });
        this.checkRoute()
        this.loadUserPlanMap();
        if (environment.enableSubscription) {
            this.loadSubscriptionDetails();
        }
        await this.getAllActiveUsersAndInvites();
        this.checkMicrosoftAzureConnectionStatus();
    }

    ngAfterViewInit() {
        // Templates will be available after view init
    }

    ngOnDestroy() {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
        this.destroy$.next();
        this.destroy$.complete();
    }

    getAllActiveUsersAndInvites() {
        return new Promise((resolve, reject) => {
            this.userService.getAllActiveUsersAndInvitesCount().subscribe((res) => {
                if (res.success) {
                    this.activeUsersCount = res.data.totalActiveUsers;
                    this.activeInvitesCount = res.data.totalActiveInvites;
                    resolve(true);
                } else {
                    reject(false);
                }
            }, error => {
                reject(false);
            });
        });
    }

    setupAzureSearchDebounce() {
        this.azureSearchSubject
            .pipe(
                debounceTime(500),
                distinctUntilChanged(),
                takeUntil(this.destroy$)
            )
            .subscribe((searchQuery: string) => {
                this.performAzureSearch(searchQuery);
            });
    }

    get templatesMap(): { [key: string]: TemplateRef<any> } {
        return {
            'nameTemplate': this.nameTemplateRef,
            'contactTemplate': this.contactTemplateRef,
            'emailTemplate': this.emailTemplateRef,
            'roleTemplate': this.roleTemplateRef,
            'additionalRolesTemplateRef': this.additionalRolesTemplateRef,
            'actionsTemplate': this.actionsTemplateRef,
            'workspaceTemplate': this.workspaceTemplateRef,
            'statusTemplate': this.statusTemplateRef,
            'userTemplate': this.userTemplateRef,
            'azureActionsTemplate': this.azureActionsTemplateRef,
            'azureRoleTemplate': this.azureRoleTemplateRef,
            'askModeTemplate': this.askModeTemplateRef,
            'agentModeTemplate': this.agentModeTemplateRef,
            'changePlanTemplate': this.changePlanTemplateRef,
            'historyActionTemplate': this.historyActionTemplateRef,
            'invitePaymentTemplate': this.invitePaymentTemplateRef
        };
    }


    /**
     * Load subscription details - fetches fresh data to pick up plan changes (e.g. userRestrictions updated via sales app)
     */
    loadSubscriptionDetails() {
        if (!this.subscriptionState.subscriptionDetails()) {
            this.subscriptionState.refreshSubscriptionDetails();
        }
        if (!this.subscriptionState.orgSubscriptionDetails()) {
            this.subscriptionState.refreshOrgSubscriptionDetails();
        }
    }

    loadUserPlanMap() {
        this.organizationService.getOrgUsersPlanMap().subscribe((res: any) => {
            if (res.success && res.data) {
                this.userPlanNames = { ...this.userPlanNames, ...res.data };
            }
        });
    }

    hasUserPlanOverride(user: IUser): boolean {
        return user._id ? user._id in this.userPlanNames : false;
    }

    getUserPlanName(user: IUser): string {
        const val = user._id ? this.userPlanNames[user._id] : null;
        if (!val) return user?.planName || this.subscriptionState.orgSubscriptionDetails()?.plan?.name || 'Select a plan';
        return typeof val === 'string' ? val : ((val as ISubscriptionDetails).plan as IPlan).name || 'Select a plan';
    }

    /** Pending user-level downgrade for this user, or null. Approved-but-not-yet-applied plan changes land here. */
    getUserPendingDowngrade(user: IUser): { name: string; effectiveAt: Date } | null {
        const val = user._id ? this.userPlanNames[user._id] : null;
        if (!val || typeof val === 'string') return null;
        const pd = val.pendingDowngrade;
        if (!pd) return null;
        return { name: pd.targetPlan?.name, effectiveAt: pd.effectiveAt };
    }


    checkMicrosoftAzureConnectionStatus() {
        this.microsoftAzureService.getAzureUsers().subscribe({
            next: (res) => {
                if (res.success && res.data) {
                    const azureMenuItem = this.addPeopleMenuItems.find(item => item.value === ADD_PEOPLE_METHOD.AZURE);
                    if (azureMenuItem) {
                        azureMenuItem.disabled = res.data.disconnected ? true : false;
                    }
                }
            },
            error: () => {
                // If error (no consent or expired), mark as disconnected
                const azureMenuItem = this.addPeopleMenuItems.find(item => item.value === ADD_PEOPLE_METHOD.AZURE);
                if (azureMenuItem) {
                    azureMenuItem.disabled = true;
                }
            }
        });
    }


    checkRoute() {
        const urlParts = this.router.url.split('/');
        let newTab = urlParts[urlParts.length - 1].split('?')[0];
        if (!newTab) newTab = 'users';

        // Clear search when switching tabs
        if (this.tab !== newTab) {
            this.searchValue = '';
        }

        this.tab = newTab;
        switch (this.tab) {
            case 'users':
                this.getUsers();
                break;
            case 'invites':
                this.getInvites();
                break;
            case 'requests':
                this.getAccessRequests();
                break;
            default:
                this.getUsers();
                break;
        }
    }

    requestLoading: boolean = false

    getAccessRequests(view: REQUEST_VIEW = REQUEST_VIEW.CURRENT) {
        const isHistory = view === REQUEST_VIEW.HISTORY;
        this.requestsTableConfig = { ...this.requestsTableConfig, loading: true };

        this.requestAccessService.getRequests(view).subscribe((res) => {
            const mapped = res.success
                ? [...res.data].reverse().map((request: IRequestAccess, index: number) => ({
                    ...request,
                    requestStatus: this.getRequestStatusLabel(request),
                    serialNumber: index + 1
                }))
                : [];

            if (isHistory) {
                this.allHistoryRequests = mapped;
                this.filterHistoryRequests();
            } else {
                this.allRequests = mapped;
                this.filterRequests();
            }
            this.requestsTableConfig = { ...this.requestsTableConfig, loading: false };
        });
    }

    private getRequestStatusLabel(request: IRequestAccess): string {
        switch (request.requestType) {
            case REQUEST_TYPE.CREATION: return 'Requested creation';
            case REQUEST_TYPE.DEACTIVATION: return 'Requested deactivation';
            case REQUEST_TYPE.PLAN_CHANGE: return 'Requested plan change';
            case REQUEST_TYPE.INVITE_PAYMENT: return 'Requested invite payment';
            default: return 'Requested credits';
        }
    }

    getUsers() {
        this.userLoading = true
        this.usersTableConfig = { ...this.usersTableConfig, loading: true };

        // If we haven't loaded all users yet, fetch from server
        if (this.allUsers.length === 0) {
            this.userService.getUsers().subscribe((res) => {
                if (res.success) {
                    this.allUsers = res.data.users.map((user: IUser, index: number) => ({
                        ...user,
                        serialNumber: index + 1
                    }));
                    this.filterUsers();
                    this.userLoading = false
                    this.usersTableConfig = { ...this.usersTableConfig, loading: false };
                }
                else {
                    this.userLoading = false
                    this.usersTableConfig = { ...this.usersTableConfig, loading: false };
                }
            })
        } else {
            // Filter existing data
            this.filterUsers();
            this.userLoading = false
            this.usersTableConfig = { ...this.usersTableConfig, loading: false };
        }
    }

    private filterUsers() {
        if (!this.searchValue.trim()) {
            this.users = [...this.allUsers];
        } else {
            const searchTerm = this.searchValue.toLowerCase().trim();
            this.users = this.allUsers.filter(user =>
                user.fullName?.toLowerCase().includes(searchTerm) ||
                user.email?.toLowerCase().includes(searchTerm) ||
                this.getRoleLabel(user.role).toLowerCase().includes(searchTerm)
            );
        }
    }

    getInvites() {
        this.inviteLoading = true
        this.invitesTableConfig = { ...this.invitesTableConfig, loading: true };

        // If we haven't loaded all invites yet, fetch from server
        if (this.allInvites.length === 0) {
            this.invitationService.getInvites().subscribe((res) => {
                if (res.success) {
                    this.allInvites = res.data.map((invite: IInvitation, index: number) => ({
                        ...invite,
                        serialNumber: index + 1
                    }));
                    this.filterInvites();
                    this.inviteLoading = false
                    this.invitesTableConfig = { ...this.invitesTableConfig, loading: false };
                }
                else {
                    this.inviteLoading = false
                    this.invitesTableConfig = { ...this.invitesTableConfig, loading: false };
                }
            })
        } else {
            // Filter existing data
            this.filterInvites();
            this.inviteLoading = false
            this.invitesTableConfig = { ...this.invitesTableConfig, loading: false };
        }
    }

    private filterInvites() {
        if (!this.searchValue.trim()) {
            this.invites = [...this.allInvites];
        } else {
            const searchTerm = this.searchValue.toLowerCase().trim();
            this.invites = this.allInvites.filter(invite =>
                invite.email?.toLowerCase().includes(searchTerm) ||
                this.getRoleLabel(invite.role).toLowerCase().includes(searchTerm)
            );
        }
    }

    private filterRequests(isHistory = false) {
        const all = isHistory ? this.allHistoryRequests : this.allRequests;
        const searchTerm = this.searchValue.toLowerCase().trim();
        const result = !searchTerm
            ? [...all]
            : all.filter(r =>
                r.email?.toLowerCase().includes(searchTerm) ||
                r.name?.toLowerCase().includes(searchTerm) ||
                this.getRoleLabel(r.role).toLowerCase().includes(searchTerm) ||
                r.status?.toLowerCase().includes(searchTerm) ||
                (r.workspace as IWorkspace)?.name?.toLowerCase().includes(searchTerm)
            );

        if (isHistory) this.historyRequests = result;
        else this.requests = result;
    }

    filterHistoryRequests() {
        this.filterRequests(true);
    }

    getHistoryActionLabel(request: IRequestAccess): string {
        return request.status ? this.titleCasePipe.transform(request.status) : '-';
    }

    get activeRequests(): IRequestAccess[] {
        return this.requestView === REQUEST_VIEW.HISTORY ? this.historyRequests : this.requests;
    }

    sortUsers(field: string, order: SORT_ORDER) {
        if (order === SORT_ORDER.NONE) {
            // Reset to original order
            this.filterUsers();
            return;
        }

        this.users.sort((a, b) => {
            let aValue: any;
            let bValue: any;

            switch (field) {
                case 'serialNumber':
                    aValue = (a as any).serialNumber;
                    bValue = (b as any).serialNumber;
                    break;
                case 'fullName':
                    aValue = a.fullName?.toLowerCase() || '';
                    bValue = b.fullName?.toLowerCase() || '';
                    break;
                case 'email':
                    aValue = a.email?.toLowerCase() || '';
                    bValue = b.email?.toLowerCase() || '';
                    break;
                case 'role':
                    aValue = this.getRoleLabel(a.role).toLowerCase();
                    bValue = this.getRoleLabel(b.role).toLowerCase();
                    break;
                default:
                    return 0;
            }

            if (aValue < bValue) {
                return order === SORT_ORDER.ASC ? -1 : 1;
            }
            if (aValue > bValue) {
                return order === SORT_ORDER.ASC ? 1 : -1;
            }
            return 0;
        });
    }

    sortInvites(field: string, order: SORT_ORDER) {
        if (order === SORT_ORDER.NONE) {
            // Reset to original order
            this.filterInvites();
            return;
        }

        this.invites.sort((a, b) => {
            let aValue: any;
            let bValue: any;

            switch (field) {
                case 'serialNumber':
                    aValue = (a as any).serialNumber;
                    bValue = (b as any).serialNumber;
                    break;
                case 'email':
                    aValue = a.email?.toLowerCase() || '';
                    bValue = b.email?.toLowerCase() || '';
                    break;
                case 'role':
                    aValue = this.getRoleLabel(a.role).toLowerCase();
                    bValue = this.getRoleLabel(b.role).toLowerCase();
                    break;
                default:
                    return 0;
            }

            if (aValue < bValue) {
                return order === SORT_ORDER.ASC ? -1 : 1;
            }
            if (aValue > bValue) {
                return order === SORT_ORDER.ASC ? 1 : -1;
            }
            return 0;
        });
    }
    sortRequests(field: string, order: SORT_ORDER) {
        if (order === SORT_ORDER.NONE) {
            // Reset to original order
            this.filterRequests();
            return;
        }

        this.requests.sort((a, b) => {
            let aValue: any;
            let bValue: any;

            switch (field) {
                case 'serialNumber':
                    aValue = (a as any).serialNumber;
                    bValue = (b as any).serialNumber;
                    break;
                case 'email':
                    aValue = a.email?.toLowerCase() || '';
                    bValue = b.email?.toLowerCase() || '';
                    break;
                case 'name':
                    aValue = a.name?.toLowerCase() || '';
                    bValue = b.name?.toLowerCase() || '';
                    break;
                case 'role':
                    aValue = this.getRoleLabel(a.role).toLowerCase();
                    bValue = this.getRoleLabel(b.role).toLowerCase();
                    break;
                case 'workspace':
                    aValue = (a.workspace as IWorkspace).name?.toLowerCase() || '';
                    bValue = (b.workspace as IWorkspace).name?.toLowerCase() || '';
                    break;
                case 'status':
                    aValue = a.status?.toLowerCase() || '';
                    bValue = b.status?.toLowerCase() || '';
                    break;
                default:
                    return 0;
            }

            if (aValue < bValue) {
                return order === SORT_ORDER.ASC ? -1 : 1;
            }
            if (aValue > bValue) {
                return order === SORT_ORDER.ASC ? 1 : -1;
            }
            return 0;
        });
    }

    addNew() {

    }

    deleteUser(userId: string) {
        this.selectedUserId = userId;
        const user = this.allUsers.find(u => u._id === userId) ?? null;
        this.selectedUserForDelete = user;

        const isBillingAdmin = user?.additionalRoles?.includes(ADDITIONAL_ROLES.BILLING_ADMIN) ?? false;
        if (isBillingAdmin) {
            this.pendingDeleteAfterBillingTransfer = true;
            this.openBillingAdminTransferDialog();
            return;
        }

        this.isDeleteUserTransfer = true;
        this.transferOwnershipDialogVisible = true;
    }

    openBillingAdminTransferDialog() {
        this.selectedBillingAdminTransferUser = null;
        this.billingAdminTransferSearchQuery = '';
        this.userService.getUsers().subscribe(res => {
            this.billingAdminTransferUsers = (res.data?.users ?? []).filter((u: IUser) => u._id !== this.selectedUserId);
            this.billingAdminTransferFilteredUsers = [...this.billingAdminTransferUsers];
            this.transferBillingAdminDialogVisible = true;
        });
    }

    onBillingAdminTransferSearch() {
        const query = this.billingAdminTransferSearchQuery.toLowerCase().trim();
        if (!query) {
            this.billingAdminTransferFilteredUsers = [...this.billingAdminTransferUsers];
            return;
        }
        this.billingAdminTransferFilteredUsers = this.billingAdminTransferUsers.filter(u => {
            const name = (u.fullName || `${u.firstName} ${u.lastName}`).toLowerCase();
            return name.includes(query) || u.email.toLowerCase().includes(query);
        });
    }

    confirmBillingAdminTransfer() {
        if (!this.selectedBillingAdminTransferUser) {
            this.toast.error('Please select a user to transfer billing admin to');
            return;
        }
        this.isTransferringBillingAdmin = true;
        this.userService.transferBillingAdmin(this.selectedBillingAdminTransferUser._id as string).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.toast.success('Billing admin transferred successfully');
                    this.transferBillingAdminDialogVisible = false;
                    if (this.pendingDeleteAfterBillingTransfer) {
                        this.pendingDeleteAfterBillingTransfer = false;
                        this.isDeleteUserTransfer = true;
                        this.transferOwnershipDialogVisible = true;
                    }
                    // Refresh user data to reflect the role change
                    this.allUsers = [];
                    this.getUsers();
                } else {
                    this.toast.error(res.message || 'Transfer failed');
                }
                this.isTransferringBillingAdmin = false;
            },
            error: (err: any) => {
                this.toast.error(err?.error?.message || 'Transfer failed');
                this.isTransferringBillingAdmin = false;
            }
        });
    }

    cancelBillingAdminTransfer() {
        this.transferBillingAdminDialogVisible = false;
        this.pendingDeleteAfterBillingTransfer = false;
        this.selectedUserId = '';
        this.selectedUserForDelete = null;
    }

    confirmDeleteUser() {
        this.userService.deleteUser(this.selectedUserId).subscribe((res) => {
            if (res.success) {
                this.allUsers = []; // Clear cache to refresh data
                this.getUsers();
                this.deleteUserDialogVisible = false;
                this.toast.success(res.message || 'User deleted successfully');
            }
        });
    }

    updateAgentModeSettings(user: IUser, key: 'askMode' | 'agentMode', value: boolean) {
        const current = user.agentModeSettings ?? { askMode: true, agentMode: true };
        const updated = { ...current, [key]: value };
        user.agentModeSettings = updated;
        this.userService.updateUserAgentModeSettings(user._id as string, updated).subscribe();
    }

    deleteInvite(inviteId: string) {
        this.selectedInviteId = inviteId;
        this.deleteInviteDialogVisible = true;
    }

    confirmDeleteInvite() {
        this.invitationService.deleteInvite(this.selectedInviteId).subscribe((res) => {
            if (res.success) {
                this.activeInvitesCount--;
                this.allInvites = []; // Clear cache to refresh data
                this.getInvites();
                this.deleteInviteDialogVisible = false;
            }
        });
    }

    onSearch() {
        if (this.tab === 'users') {
            this.getUsers();
        } else if (this.tab === 'invites') {
            this.getInvites();
        } else if (this.tab === 'requests') {
            this.requestView === REQUEST_VIEW.HISTORY ? this.filterHistoryRequests() : this.filterRequests();
        }
    }

    onFilter(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        // Global filter will be handled by the data-table component itself
        // We don't need to manually filter here as the data-table has built-in global filter
    }

    onMenuItemSelected(item: CustomMenuItem) {
        if (item.value === ADD_PEOPLE_METHOD.MANUAL) {
            this.openInviteDialog();
        } else if (item.value === ADD_PEOPLE_METHOD.AZURE) {
            this.openAzureDialog();
        }
    }

    get effectiveMaxUsers(): number | null {
        const plan = this.subscriptionState.orgSubscriptionDetails()?.plan;
        if (!plan) {
            return null;
        }
        const max = plan.userRestrictions?.max;
        if (max === undefined || max === null || max === 0) {
            return null; // Unlimited
        }
        return max;
    }

    get curretPlanMaxUsers(): number | null {
        const orgPlan = this.subscriptionState.orgSubscriptionDetails()?.plan;
        const customerOptedFor = orgPlan?.userRestrictions?.customerOptedFor ?? 0;
        return customerOptedFor > 0 ? customerOptedFor : null;
    }

    /**
     * Checks if the user limit has been reached based on active users and invites
     * @param showLegacyToast - If true, shows a toast warning for legacy plan.maxUsers check
     * @param showMaxUsersDialog - If true, shows the max users reached dialog
     * @param newUsersCount - Additional users/invites to consider in the check
     * @returns true if limit is reached, false otherwise
     */
    checkUserLimitReached(showMaxUsersDialog: boolean = true, newUsersCount: number = 0): boolean {
        const activeUsersCount = this.activeUsersCount;
        const activeInvitesCount = this.activeInvitesCount;
        const totalCount = activeUsersCount + activeInvitesCount + newUsersCount;

        const maxUsers = this.effectiveMaxUsers;
        if (maxUsers !== null && totalCount >= maxUsers) {
            this.maxUsersAllowed = maxUsers;
            if (showMaxUsersDialog) {
                this.maxUsersReachedDialogVisible = true;
            }
            return true;
        }

        return false;
    }

    /**
     * Gets the maximum number of additional invites that can be sent
     * @returns number of remaining slots available, or null if unlimited
     */
    getRemainingInviteSlots(): number | null {
        const activeUsersCount = this.activeUsersCount;
        const activeInvitesCount = this.activeInvitesCount;
        const totalCount = activeUsersCount + activeInvitesCount;

        const maxUsers = this.effectiveMaxUsers;
        if (maxUsers === null) {
            return null;
        }
        const remaining = maxUsers - totalCount;
        return remaining > 0 ? remaining : 0;
    }

    /**
     * Checks if the selected Azure people can be added without exceeding the limit
     * @returns true if selected people can be added, false otherwise
     */
    canAddSelectedAzurePeople(): boolean {
        if (this.selectedAzurePeople.length === 0) {
            return false;
        }
        return !this.checkUserLimitReached(false, this.selectedAzurePeople.length);
    }

    /**
     * Checks if more members can be added to the manual invite list
     * @returns true if more members can be added, false otherwise
     */
    canAddMoreMembers(): boolean {
        const remainingSlots = this.getRemainingInviteSlots();
        const currentMembersCount = this.members.length;

        if (remainingSlots === null) {
            return true; // Unlimited
        }

        return currentMembersCount < remainingSlots;
    }

    onAddPeopleClick(event: Event, menu: any) {
        if (this.checkUserLimitReached()) {
            return;
        }

        // If check passes, show the menu
        menu.toggle(event);
    }

    openInviteDialog() {
        if (this.checkUserLimitReached(true)) {
            return;
        }

        this.email = '';
        this.inviteDialogVisible = true;
    }

    openAzureDialog() {
        if (this.checkUserLimitReached()) {
            return;
        }

        this.azureDialogVisible = true;
        this.azureSearchValue = '';
        this.currentSearchQuery = '';
        this.selectedAzurePeople = [];
        this.selectAllAzure = false;
        this.isLoadingSelectAllAzure = false;
        this.selectedAzurePeopleMap.clear();

        this.azurePeopleList = [];
        this.azureNextLink = null;
        this.hasMoreAzureUsers = false;
        this.totalAzureUsers = 0;

        if (!this.isLoadingAzurePeople) {
            this.fetchAzurePeople(true, '');
        }
    }

    loadSearchAnimation() {
        this.http.get('/animations/search.json').subscribe({
            next: (data) => {
                this.searchAnimationData = data;
            },
            error: (error) => {
                console.error('Failed to load search animation:', error);
            }
        });
    }

    totalAzureUsers: number = 0;
    currentSearchQuery: string = '';

    onAzureSearchChange() {
        this.azureSearchSubject.next(this.azureSearchValue);
    }

    performAzureSearch(searchQuery: string) {
        const trimmedQuery = searchQuery?.trim() || '';
        this.currentSearchQuery = trimmedQuery;

        if (trimmedQuery === '') {
            this.fetchAzurePeople(true, '');
        } else {
            this.fetchAzurePeople(true, trimmedQuery);
        }
    }

    refreshAzurePeople() {
        this.azureSearchValue = '';
        this.currentSearchQuery = '';
        this.fetchAzurePeople(true, '');
    }

    fetchAzurePeople(reset: boolean = false, searchQuery?: string) {
        if (reset) {
            this.preserveSelectedUsers();
            this.azurePeopleList = [];
            this.azureNextLink = null;
            this.hasMoreAzureUsers = false;
            this.isLoadingAzurePeople = true;
        } else {
            this.isLoadingMoreAzureUsers = true;
        }

        const query = searchQuery !== undefined ? searchQuery : this.currentSearchQuery;
        this.microsoftAzureService.getAzureUsers(this.azureNextLink || undefined, query).subscribe({
            next: (response) => {
                if (response.success) {
                    const newUsers = response.data.value.map((user: any, index: number) => {
                        const userId = user.id || `${this.azurePeopleList.length + index + 1}`;
                        const existingSelection = this.selectedAzurePeopleMap.get(userId);

                        return {
                            id: userId,
                            name: user.displayName || user.givenName || user.firstName || '',
                            email: user.mail || user.userPrincipalName || user.email || '',
                            position: user.jobTitle || '',
                            role: existingSelection?.role || USER_ROLE.MEMBER,
                            selected: existingSelection?.selected || false
                        };
                    });

                    if (reset) {
                        this.totalAzureUsers = response.data.totalCount || 0;
                    }

                    this.azurePeopleList = reset ? newUsers : [...this.azurePeopleList, ...newUsers];
                    this.restoreSelectedUsers();
                    this.azureNextLink = response.data.nextLink || null;
                    this.hasMoreAzureUsers = !!this.azureNextLink;

                    this.isLoadingAzurePeople = false;
                    this.isLoadingMoreAzureUsers = false;
                    this.updateSelectedAzurePeople();
                } else {
                    this.isLoadingAzurePeople = false;
                    this.isLoadingMoreAzureUsers = false;
                    this.toast.error(response.message || 'Failed to fetch people from Azure');
                }
            },
            error: (error) => {
                this.isLoadingAzurePeople = false;
                this.isLoadingMoreAzureUsers = false;
                console.error('Error fetching Azure users:', error);
                this.toast.error(error?.error?.message || 'Failed to fetch people from Azure. Please try again.');
            }
        });
    }

    preserveSelectedUsers() {
        this.azurePeopleList.forEach(person => {
            if (person.selected) {
                this.selectedAzurePeopleMap.set(person.id, {
                    selected: true,
                    role: person.role
                });
            }
        });
    }

    restoreSelectedUsers() {
        this.azurePeopleList.forEach(person => {
            const savedSelection = this.selectedAzurePeopleMap.get(person.id);
            if (savedSelection) {
                person.selected = savedSelection.selected;
                person.role = savedSelection.role;
            }
        });
    }

    onAzureListScroll(event: Event) {
        const element = event.target as HTMLElement;
        const scrollTop = element.scrollTop;
        const scrollHeight = element.scrollHeight;
        const clientHeight = element.clientHeight;

        if (scrollTop + clientHeight >= scrollHeight - 50 && this.hasMoreAzureUsers && !this.isLoadingMoreAzureUsers) {
            this.fetchAzurePeople(false, this.currentSearchQuery);
        }
    }

    toggleSelectAllAzure() {
        if (this.selectAllAzure && this.hasMoreAzureUsers && !this.isLoadingMoreAzureUsers) {
            this.isLoadingSelectAllAzure = true;
            this.loadAllAzureUsersAndSelect();
        } else {
            // If trying to select all, check remaining slots
            if (this.selectAllAzure) {
                const remainingSlots = this.getRemainingInviteSlots();
                const currentSelectedCount = this.azurePeopleList.filter(p => p.selected).length;
                const unselectedCount = this.azurePeopleList.filter(p => !p.selected).length;

                // If there's a limit and selecting all would exceed it
                if (remainingSlots !== null) {
                    const availableSlots = remainingSlots - currentSelectedCount;
                    if (availableSlots <= 0) {
                        this.toast.warn(`You can only invite ${remainingSlots} more ${remainingSlots === 1 ? 'person' : 'people'}. Please remove some selections or wait for existing invites to be accepted.`);
                        this.selectAllAzure = false;
                        return;
                    }
                    // Only select up to the available slots
                    let selected = 0;
                    this.azurePeopleList.forEach(person => {
                        if (!person.selected && selected < availableSlots) {
                            person.selected = true;
                            selected++;
                        }
                    });
                    this.updateSelectedAzurePeople();
                    if (selected < unselectedCount) {
                        this.toast.warn(`Only ${selected} ${selected === 1 ? 'person' : 'people'} selected due to user limit.`);
                    }
                    return;
                }
            }

            // No limit or deselecting all
            this.azurePeopleList.forEach(person => {
                person.selected = this.selectAllAzure;
            });
            this.updateSelectedAzurePeople();
        }
    }

    loadAllAzureUsersAndSelect() {
        if (!this.hasMoreAzureUsers || this.isLoadingMoreAzureUsers) {
            // All users loaded, now select respecting the limit
            const remainingSlots = this.getRemainingInviteSlots();
            const currentSelectedCount = this.azurePeopleList.filter(p => p.selected).length;

            if (remainingSlots !== null) {
                const availableSlots = remainingSlots - currentSelectedCount;
                if (availableSlots <= 0) {
                    this.toast.warn(`You can only invite ${remainingSlots} more ${remainingSlots === 1 ? 'person' : 'people'}. Please remove some selections or wait for existing invites to be accepted.`);
                    this.selectAllAzure = false;
                    this.isLoadingSelectAllAzure = false;
                    return;
                }

                // Only select up to the available slots
                let selected = 0;
                const unselectedCount = this.azurePeopleList.filter(p => !p.selected).length;
                this.azurePeopleList.forEach(person => {
                    if (!person.selected && selected < availableSlots) {
                        person.selected = true;
                        selected++;
                    }
                });
                this.updateSelectedAzurePeople();
                this.isLoadingSelectAllAzure = false;

                if (selected < unselectedCount) {
                    this.toast.warn(`Only ${selected} ${selected === 1 ? 'person' : 'people'} selected due to user limit.`);
                }
            } else {
                // No limit, select all
                this.azurePeopleList.forEach(person => {
                    person.selected = this.selectAllAzure;
                });
                this.updateSelectedAzurePeople();
                this.isLoadingSelectAllAzure = false;
            }
            return;
        }

        this.isLoadingMoreAzureUsers = true;
        this.microsoftAzureService.getAzureUsers(this.azureNextLink || undefined, this.currentSearchQuery).subscribe({
            next: (response) => {
                if (response.success) {
                    const newUsers = response.data.value.map((user: any, index: number) => ({
                        id: user.id || `${this.azurePeopleList.length + index + 1}`,
                        name: user.displayName || user.givenName || user.firstName || '',
                        email: user.mail || user.userPrincipalName || user.email || '',
                        position: user.jobTitle || '',
                        role: USER_ROLE.MEMBER,
                        selected: false
                    }));
                    this.azurePeopleList = [...this.azurePeopleList, ...newUsers];
                    this.azureNextLink = response.data.nextLink || null;
                    this.hasMoreAzureUsers = !!this.azureNextLink;
                    this.isLoadingMoreAzureUsers = false;

                    this.loadAllAzureUsersAndSelect();
                } else {
                    this.isLoadingMoreAzureUsers = false;
                    this.isLoadingSelectAllAzure = false;
                    this.toast.error(response.message || 'Failed to fetch people from Azure');
                }
            },
            error: (error) => {
                this.isLoadingMoreAzureUsers = false;
                this.isLoadingSelectAllAzure = false;
                console.error('Error fetching Azure users:', error);
                this.toast.error(error?.error?.message || 'Failed to fetch people from Azure. Please try again.');
            }
        });
    }

    toggleAzurePersonSelection(person: any) {
        // If trying to select, check if we have remaining slots
        if (!person.selected) {
            const remainingSlots = this.getRemainingInviteSlots();
            const currentSelectedCount = this.azurePeopleList.filter(p => p.selected).length;

            // If there's a limit and we've reached it
            if (remainingSlots !== null && currentSelectedCount >= remainingSlots) {
                this.toast.warn(`You can only invite ${remainingSlots} more ${remainingSlots === 1 ? 'person' : 'people'}. Please remove some selections or wait for existing invites to be accepted.`);
                return;
            }
        }

        person.selected = !person.selected;
        this.updateSelectedAzurePeople();
        this.selectAllAzure = this.azurePeopleList.length > 0 &&
            this.azurePeopleList.every(p => p.selected);
    }

    updateSelectedAzurePeople() {
        this.selectedAzurePeople = this.azurePeopleList
            .filter(p => p.selected)
            .map((person, index) => ({ ...person, rowIndex: index + 1 }));

        this.selectedAzurePeople.forEach(person => {
            this.selectedAzurePeopleMap.set(person.id, {
                selected: true,
                role: person.role
            });
        });
    }

    removeAzurePerson(person: any) {
        const originalPerson = this.azurePeopleList.find(p => p.id === person.id);
        if (originalPerson) {
            originalPerson.selected = false;
        }
        this.selectedAzurePeopleMap.delete(person.id);
        this.updateSelectedAzurePeople();
        this.selectAllAzure = this.azurePeopleList.length > 0 &&
            this.azurePeopleList.every(p => p.selected);
    }

    addSelectedAzurePeople() {
        if (this.selectedAzurePeople.length === 0) {
            this.toast.warn('Please select at least one person to add');
            return;
        }

        // Check if adding these invites would exceed the limit
        if (this.checkUserLimitReached(false, this.selectedAzurePeople.length)) {
            return;
        }

        // Prepare invite data from selected Azure people
        const inviteData = this.selectedAzurePeople.map(person => ({
            email: person.email,
            role: person.role
        }));

        // Send invites
        this.invitationService.sendInvite(inviteData, USER_SOURCE.AZURE).subscribe((res) => {
            if (res.success) {
                this.toast.success(`${this.selectedAzurePeople.length} people invited successfully`);
                this.azureDialogVisible = false;
                // Reset Azure dialog state
                this.azurePeopleList = [];
                this.azureNextLink = null;
                this.hasMoreAzureUsers = false;
                this.selectedAzurePeople = [];
                this.selectAllAzure = false;
                this.azureSearchValue = '';
                // Refresh invites list
                this.allInvites = [];
                this.getInvites();
            } else {
                this.toast.error(res.message || 'Failed to send invites');
            }
        });
    }

    sendMail() {
        // Check remaining slots using the same logic as Azure dialog
        const remainingSlots = this.getRemainingInviteSlots();
        const membersCount = this.members.length;

        if (remainingSlots !== null) {
            // If there's a limit and we've reached it
            if (remainingSlots === 0 || membersCount > remainingSlots) {
                this.toast.warn(`You can only invite ${remainingSlots} more ${remainingSlots === 1 ? 'person' : 'people'}. Please remove some members or wait for existing invites to be accepted.`);
                return;
            }
        }

        this.invitationService.sendInvite(this.members, USER_SOURCE.MAIL).subscribe((res) => {
            if (res.success) {
                if (res.data?.message) {
                    this.toast.info(res.data.message);

                } else {
                    this.activeInvitesCount += this.members.length;
                    this.toast.success('Invites sent successfully');
                }
                this.inviteDialogVisible = false;
                this.members = [];
                this.allInvites = []; // Clear cache to refresh data
                this.getInvites()
            }
        });
    }

    validateEmail() {
        return validateEmail(this.email);
    }

    async checkMailExists(email: string) {
        const res = await this.invitationService.checkEmailExists(email).toPromise();
        if (!res) return false;
        if (res.success) {
            if (res.data.exists) {
                this.toast.error(res.data.message)
            }
            return res.data.exists;
        } else {
            return false
        }
    }

    async addMember() {
        // Check remaining slots using the same logic as Azure dialog
        const remainingSlots = this.getRemainingInviteSlots();
        const currentMembersCount = this.members.length;

        if (remainingSlots !== null) {
            // If there's a limit and we've reached it
            if (remainingSlots === 0 || currentMembersCount >= remainingSlots) {
                this.toast.warn(`You can only invite ${remainingSlots} more ${remainingSlots === 1 ? 'person' : 'people'}. Please remove some members or wait for existing invites to be accepted.`);
                return;
            }
            // If adding this member would exceed the limit
            if (currentMembersCount + 1 > remainingSlots) {
                const availableSlots = remainingSlots - currentMembersCount;
                this.toast.warn(`You can only add ${availableSlots} more ${availableSlots === 1 ? 'member' : 'members'}. Please remove some members first.`);
                return;
            }
        }

        const mailExists = await this.checkMailExists(this.email)
        if (mailExists || this.members.some(member => member.email === this.email)) {
            this.email = '';
            return;
        }
        if (validateEmail(this.email)) {
            this.members.push({
                email: this.email,
                role: USER_ROLE.MEMBER
            });
            this.email = '';
        } else {
            this.toast.error('Please enter a valid email address');
        }
    }

    removeMember(index: number) {
        this.members.splice(index, 1);
    }

    onInviteDialogClosed() {
        this.inviteDialogVisible = false;
        this.members = [];
        this.email = '';
    }

    updateUserRole(user: IUser) {
        if (user.role === USER_ROLE.MEMBER && user.additionalRoles?.length) {
            user.additionalRoles = [];
        }
        this.userService.updateUser(user).subscribe((res) => {
            if (res.success) {
                this.toast.success("User role updated successfully");
                const allUserIndex = this.allUsers.findIndex(u => u._id === user._id);
                if (allUserIndex !== -1) {
                    this.allUsers[allUserIndex] = { ...user };
                }
                const filteredUserIndex = this.users.findIndex(u => u._id === user._id);
                if (filteredUserIndex !== -1) {
                    this.users[filteredUserIndex] = { ...user };
                }
            }
        })
    }

    updateInviteUser(invite: IInvitation) {
        this.invitationService.updateInviteUser(invite).subscribe((res) => {
            if (res.success) {
                this.toast.success("Invite updated successfully");
                const allInviteIndex = this.allInvites.findIndex(i => i._id === invite._id);
                if (allInviteIndex !== -1) {
                    this.allInvites[allInviteIndex] = { ...invite };
                }
                const filteredInviteIndex = this.invites.findIndex(i => i._id === invite._id);
                if (filteredInviteIndex !== -1) {
                    this.invites[filteredInviteIndex] = { ...invite };
                }
            }
        })
    }

    getRoleLabel(role: USER_ROLE | SHARE_ACCESS) {
        switch (role) {
            case USER_ROLE.SUPER_ADMIN:
                return 'Account owner';
            case USER_ROLE.ADMIN:
                return 'Organization admin';
            case USER_ROLE.MEMBER:
                return 'Organization member';
            case SHARE_ACCESS.VIEW:
                return 'Viewer';
            case SHARE_ACCESS.EDIT:
                return 'Editor';
            case SHARE_ACCESS.COMMENT:
                return 'Commenter';
            default:
                return 'Organization member';
        }
    }

    getAdditionalRoleLabel(role: ADDITIONAL_ROLES): string {
        switch (role) {
            case ADDITIONAL_ROLES.BILLING_ADMIN:
                return 'Billing Admin';
            default:
                return role;
        }
    }

    updateUserAdditionalRoles(user: IUser, event: SelectChangeEvent) {
        user.additionalRoles = event.value ? [event.value as ADDITIONAL_ROLES] : [];
        this.userService.updateUser(user).subscribe((res) => {
            if (res.success) {
                this.toast.success('User additional role updated successfully');
                const allUserIndex = this.allUsers.findIndex(u => u._id === user._id);
                if (allUserIndex !== -1) {
                    this.allUsers[allUserIndex] = { ...user };
                }
                const filteredUserIndex = this.users.findIndex(u => u._id === user._id);
                if (filteredUserIndex !== -1) {
                    this.users[filteredUserIndex] = { ...user };
                }
            }
        });
    }

    approveRequest(requestId: string) {
        this.selectedRequestId = requestId;
        this.selectedRequest = this.allRequests.find(r => r._id === requestId) || null;

        if (this.selectedRequest?.requestType === REQUEST_TYPE.DEACTIVATION) {
            this.transferOwnershipDialogVisible = true;
        } else if (this.selectedRequest?.requestType === REQUEST_TYPE.PLAN_CHANGE) {
            if (!this.availablePlans.length) this.loadOrgPlans();
            this.proratedCharge = null;
            this.isFetchingProratedCharge = true;
            this.approvePlanChangeDialogVisible = true;
            this.paymentService.getProratedCharge(requestId).subscribe({
                next: (res: any) => {
                    if (res?.success) {
                        this.proratedCharge = res.data?.proratedCharge ?? null;
                    }
                    this.isFetchingProratedCharge = false;
                },
                error: () => {
                    this.isFetchingProratedCharge = false;
                }
            });
        } else {
            this.approveRequestDialogVisible = true;
        }
    }

    confirmApproveRequest() {
        if (!this.selectedRequest) {
            this.toast.error('Request not found');
            return;
        }
        this.requestAccessService.approveRequest({
            requestIds: [this.selectedRequestId],
            role: this.selectedRequest.role
        }).subscribe((res) => {
            if (res.success) {
                const data = (res as any).data;
                if (data?.requiresPayment && data?.checkoutUrl) {
                    this.approveRequestDialogVisible = false;
                    window.location.href = data.checkoutUrl;
                    return;
                }
                this.toast.success('Request approved successfully');
                this.getAccessRequests();
                this.approveRequestDialogVisible = false;
            }
        });
    }

    getTransferFunction() {
        return (transferEmail: string) => {
            // If this is for delete user, use transferOwnership endpoint
            if (this.isDeleteUserTransfer) {
                if (!this.selectedUserId) {
                    this.toast.error('User ID not found');
                    return new Observable(observer => {
                        observer.error({ error: { message: 'User ID not found' } });
                        observer.complete();
                    });
                }
                return this.requestAccessService.transferOwnership([this.selectedUserId], transferEmail);
            }

            if (this.bulkSelectedRequestIds.length > 0) {
                // Filter to only include deactivation requests
                const deactivationRequestIds = this.allRequests
                    .filter(r =>
                        this.bulkSelectedRequestIds.includes(r._id) &&
                        r.requestType === REQUEST_TYPE.DEACTIVATION
                    )
                    .map(r => r._id);

                if (deactivationRequestIds.length === 0) {
                    this.toast.error('No valid deactivation requests found');
                    return new Observable(observer => {
                        observer.error({ error: { message: 'No valid deactivation requests found' } });
                        observer.complete();
                    });
                }

                return this.requestAccessService.approveDeactivation(deactivationRequestIds, transferEmail);
            }

            // Otherwise, it's for single deactivation request approval
            if (!this.selectedRequestId) {
                this.toast.error('Request ID not found');
                return new Observable(observer => {
                    observer.error({ error: { message: 'Request ID not found' } });
                    observer.complete();
                });
            }

            return this.requestAccessService.approveDeactivation([this.selectedRequestId], transferEmail);
        };
    }

    onTransferOwnershipConfirmed(transferEmail: string) {
        // Backward compatibility - this should not be called if transferFunction is provided
        if (this.isDeleteUserTransfer) {
            // For delete user transfer
            if (!this.selectedUserId) {
                this.toast.error('User ID not found');
                return;
            }
            this.requestAccessService.transferOwnership([this.selectedUserId], transferEmail).subscribe({
                next: (res) => {
                    if (res.success) {
                        this.toast.success(res.message || 'Ownership transferred and user deleted successfully');
                        this.transferOwnershipDialogVisible = false;
                        this.isDeleteUserTransfer = false;
                        this.selectedUserForDelete = null;
                        this.allUsers = []; // Clear cache to refresh data
                        this.getUsers();
                    } else {
                        this.toast.error(res.message || 'Failed to transfer ownership');
                    }
                },
                error: (err) => {
                    this.toast.error(err?.error?.message || 'Failed to transfer ownership');
                }
            });
        } else {
            // For deactivation request approval
            if (!this.selectedRequestId) {
                this.toast.error('Request ID not found');
                return;
            }

            this.requestAccessService.approveDeactivation([this.selectedRequestId], transferEmail).subscribe({
                next: (res) => {
                    if (res.success) {
                        this.toast.success(res.message || 'Deactivation approved and ownership transferred successfully');
                        this.transferOwnershipDialogVisible = false;
                        this.getAccessRequests();
                    } else {
                        this.toast.error(res.message || 'Failed to approve deactivation');
                    }
                },
                error: (err) => {
                    this.toast.error(err?.error?.message || 'Failed to approve deactivation');
                }
            });
        }
    }

    onTransferCompleted(result: { success: boolean; message?: string }) {
        if (result.success) {
            if (this.isDeleteUserTransfer) {
                // For delete user transfer, refresh users list
                this.toast.success(result.message || 'Ownership transferred and user deleted successfully');
                this.transferOwnershipDialogVisible = false;
                this.isDeleteUserTransfer = false;
                this.selectedUserForDelete = null;
                this.allUsers = []; // Clear cache to refresh data
                this.getUsers();
            } else {
                // For deactivation request approval (single or bulk)
                const isBulkOperation = this.bulkSelectedRequestIds.length > 0;
                const requestCount = isBulkOperation ? this.bulkSelectedRequestIds.length : 1;
                const message = result.message ||
                    (isBulkOperation
                        ? `${requestCount} deactivation request(s) approved and ownership transferred successfully`
                        : 'Deactivation approved and ownership transferred successfully');

                this.toast.success(message);
                this.transferOwnershipDialogVisible = false;
                this.resetSelectionState();
                this.getAccessRequests();
            }
        } else {
            // Error toast is already shown in the dialog component
        }
    }

    cancelTransferOwnership() {
        this.transferOwnershipDialogVisible = false;
        this.selectedRequest = null;
        this.isDeleteUserTransfer = false;
        this.selectedUserForDelete = null;
    }

    /**
     * Resets the selection state to initial state after bulk actions
     * Clears all selected items and bulk operation IDs
     */
    resetSelectionState() {
        this.selectedRequests = [];
        this.bulkSelectedRequestIds = [];
    }

    rejectRequest(requestId: string) {
        this.selectedRequestId = requestId;
        this.selectedRequest = this.allRequests.find(r => r._id === requestId) || null;
        this.rejectRequestDialogVisible = true;
    }

    getRequestMenuItems(request: IRequestAccess): CustomMenuItem[] {
        const isOwn = this.isCurrentUserRequest(request);
        if (request.requestType === REQUEST_TYPE.CREATION) {
            return [
                { label: 'Approve user creation', icon: 'check', iconSource: IconSourceEnum.LUCIDE, value: 'approve_creation', disabled: isOwn, class: 'text-success', callback: () => this.approveRequest(request._id) },
                { label: 'Reject user creation', icon: 'x', iconSource: IconSourceEnum.LUCIDE, value: 'reject_creation', disabled: isOwn, class: 'text-danger', callback: () => this.rejectRequest(request._id) }
            ];
        } else if (request.requestType === REQUEST_TYPE.DEACTIVATION) {
            return [
                { label: 'Approve deactivation', icon: 'check', iconSource: IconSourceEnum.LUCIDE, value: 'approve_deactivation', disabled: isOwn, class: 'text-success', callback: () => this.approveRequest(request._id) },
                { label: 'Reject deactivation', icon: 'x', iconSource: IconSourceEnum.LUCIDE, value: 'reject_deactivation', disabled: isOwn, class: 'text-danger', callback: () => this.rejectRequest(request._id) }
            ];
        } else if (request.requestType === REQUEST_TYPE.CREDITS) {
            return [
                { label: 'Accept', icon: 'check', iconSource: IconSourceEnum.LUCIDE, value: 'approve_credits', class: 'text-success', callback: () => this.approveCreditRequest(request._id) },
                { label: 'Reject', icon: 'x', iconSource: IconSourceEnum.LUCIDE, value: 'reject_credits', class: 'text-danger', callback: () => this.rejectCreditRequest(request._id) }
            ];
        } else if (request.requestType === REQUEST_TYPE.PLAN_CHANGE) {
            return [
                { label: 'Approve plan change', icon: 'check', iconSource: IconSourceEnum.LUCIDE, value: 'approve_plan_change', class: 'text-success', callback: () => this.approveRequest(request._id) },
                { label: 'Reject plan change', icon: 'x', iconSource: IconSourceEnum.LUCIDE, value: 'reject_plan_change', class: 'text-danger', callback: () => this.rejectRequest(request._id) }
            ];
        } else if (request.requestType === REQUEST_TYPE.INVITE_PAYMENT) {
            return [
                { label: 'Accept', icon: 'check', iconSource: IconSourceEnum.LUCIDE, value: 'accept_invite_payment', class: 'text-success', callback: () => this.acceptInvitePaymentRequest(request) },
                { label: 'Reject', icon: 'x', iconSource: IconSourceEnum.LUCIDE, value: 'reject_invite_payment', class: 'text-danger', callback: () => this.rejectRequest(request._id) }
            ];
        }
        return [];
    }

    private openCheckoutWithPricing(items: CheckoutItem[]) {
        this.checkoutItems = items;
        this.checkoutDialogVisible = true;
    }

    approveCreditRequest(requestId: string) {
        const request = this.allRequests.find(r => r._id === requestId);
        if (!request) return;
        this.openCheckoutWithPricing([{
            requestId: request._id,
            request: request,
            askCredits: request.metadata?.['ask'] ?? 0,
            agentCredits: request.metadata?.['agent'] ?? 0
        }]);
    }

    getSelectedCreditRequests(): IRequestAccess[] {
        return this.selectedRequests.filter(req => req.requestType === REQUEST_TYPE.CREDITS && req.status === 'REQUESTED');
    }

    openBulkApproveCreditDialog() {
        const requests = this.getSelectedCreditRequests();
        if (requests.length === 0) return;
        this.openCheckoutWithPricing(requests.map(r => ({
            requestId: r._id,
            request: r,
            askCredits: r.metadata?.['ask'] ?? 0,
            agentCredits: r.metadata?.['agent'] ?? 0
        })));
    }

    openBulkRejectCreditDialog() {
        const requests = this.getSelectedCreditRequests();
        if (requests.length === 0) return;
        this.bulkSelectedRequestIds = requests.map(r => r._id);
        this.bulkRejectCreditDialogVisible = true;
    }

    confirmBulkRejectCredit() {
        const rejectPromises = this.bulkSelectedRequestIds.map(id =>
            lastValueFrom(this.requestAccessService.removeRequest(id))
        );
        Promise.all(rejectPromises).then(results => {
            const successCount = results.filter(r => r?.success).length;
            if (successCount > 0) {
                this.toast.success(`${successCount} credit request(s) rejected successfully`);
            }
            if (successCount < this.bulkSelectedRequestIds.length) {
                this.toast.warn('Some requests could not be rejected');
            }
            this.bulkRejectCreditDialogVisible = false;
            this.resetSelectionState();
            this.getAccessRequests();
        }).catch(() => {
            this.toast.error('Failed to reject credit requests');
            this.bulkRejectCreditDialogVisible = false;
            this.resetSelectionState();
        });
    }

    getBillingDaysRemaining(): number {
        const orgDetails = this.subscriptionState.orgSubscriptionDetails();
        if (!orgDetails) return 0;
        const nextBillingDate = orgDetails?.nextBillingDate;
        if (!nextBillingDate) return 0;
        const msRemaining = new Date(nextBillingDate).getTime() - Date.now();
        return Math.max(0, Math.ceil(msRemaining / (1000 * 60 * 60 * 24)));
    }

    getBillingCycleDays(): number {
        const orgDetails = this.subscriptionState.orgSubscriptionDetails();
        if (!orgDetails) return 30;
        const term = orgDetails?.billing?.term || TermUnit.MONTH;
        return termToCycleDays(term as TermUnit);
    }

    getProratedCharge(): number {
        if (this.proratedCharge !== null) return this.proratedCharge;
        const monthlyDiff = this.getPlanChangeDiff();
        if (monthlyDiff <= 0) return 0;
        const daysRemaining = this.getBillingDaysRemaining();
        const cycleDays = this.getBillingCycleDays();
        const term = this.subscriptionState.orgSubscriptionDetails()?.billing?.term || TermUnit.MONTH;
        const termDiff = monthlyDiff * termToMonthlyDivisor(term);
        if (cycleDays === 0) return termDiff;
        if (daysRemaining === 0) return termDiff;
        return termDiff * (daysRemaining / cycleDays);
    }

    getOrgMonthlyPrice(): number {
        const orgDetails = this.subscriptionState.orgSubscriptionDetails();
        if (!orgDetails) return 0;
        const billing = orgDetails?.billing;
        if (billing?.price !== undefined && billing?.term) {
            return billing.price / termToMonthlyDivisor(billing.term);
        }
        const plan = orgDetails?.plan;
        const billingTerm = (billing?.term ?? null) as TermUnit | null;
        if (typeof plan === 'object' && plan?.pricing && billingTerm) {
            const orgPricing = (plan.pricing).find(p =>
                p.entity === EntityUnit.USER && p.term === billingTerm
            );
            if (orgPricing) {
                return orgPricing.price / termToMonthlyDivisor(orgPricing.term);
            }
        }
        return 0;
    }

    getRequestedPlanActualPrice(): number {
        if (!this.selectedRequest) return 0;
        const planId = this.selectedRequest.metadata?.['planId'];
        const term = this.selectedRequest.metadata?.['pricingTerm'] as TermUnit;
        const orgDetails = this.subscriptionState.orgSubscriptionDetails();
        const orgPlanId = typeof orgDetails?.plan === 'object' ? (orgDetails.plan as any)?._id : orgDetails?.plan;
        const orgLinkedDefaultPlanId = typeof orgDetails?.plan === 'object' ? (orgDetails.plan as any)?.linkedDefaultPlan : undefined;
        if (orgDetails?.billing?.price !== undefined && planId && (orgPlanId === planId || orgLinkedDefaultPlanId === planId)) {
            return orgDetails.billing.price;
        }
        const plan = this.availablePlans.find(p => p._id === planId);
        if (plan?.pricing && term) {
            const pricing = plan.pricing.find(p => p.entity === EntityUnit.USER && p.term === term);
            if (pricing) return pricing.price;
        }
        return this.selectedRequest.metadata?.['pricingPrice'] ?? 0;
    }

    getRequestedPlanMonthlyPrice(): number {
        if (!this.selectedRequest) return 0;
        const price = this.getRequestedPlanActualPrice();
        const term = this.selectedRequest.metadata?.['pricingTerm'] as TermUnit;
        return term ? price / termToMonthlyDivisor(term) : price;
    }

    getOrgActualTerm(): string {
        const orgDetails = this.subscriptionState.orgSubscriptionDetails();
        if (!orgDetails) return 'month';
        const billing = orgDetails?.billing;
        const term = billing?.term || (orgDetails?.billingCycle === 'yearly' ? TermUnit.YEAR : TermUnit.MONTH);
        return (term as string).toLowerCase();
    }

    getOldPlanActualPrice(): number {
        if (!this.selectedRequest) return 0;
        const oldPlanId = this.selectedRequest.metadata?.['oldPlanId'];
        const oldPlanName = this.selectedRequest.metadata?.['oldPlanName'];
        const orgDetails = this.subscriptionState.orgSubscriptionDetails();
        const orgPlanId = typeof orgDetails?.plan === 'object' ? (orgDetails.plan as any)?._id : orgDetails?.plan;
        const orgLinkedDefaultPlanId = typeof orgDetails?.plan === 'object' ? (orgDetails.plan as any)?.linkedDefaultPlan : undefined;
        if (orgDetails?.billing?.price !== undefined && oldPlanId && (orgPlanId === oldPlanId || orgLinkedDefaultPlanId === oldPlanId)) {
            return orgDetails.billing.price;
        }
        const oldPlan = this.availablePlans.find(p => p._id === oldPlanId || p.name === oldPlanName) ?? null;
        if (!oldPlan) return 0;
        const subDetails = this.subscriptionState.subscriptionDetails();
        const billing = subDetails?.subscriptions?.billing;
        const billingTerm = (billing?.term || (subDetails?.subscriptions?.billingCycle === 'yearly' ? TermUnit.YEAR : TermUnit.MONTH)) as TermUnit;
        const pricing = oldPlan.pricing?.find(p => p.entity === EntityUnit.USER && p.term === billingTerm);
        return pricing?.price ?? 0;
    }

    getOldPlanMonthlyPrice(): number {
        const oldPrice = this.getOldPlanActualPrice();
        const subDetails = this.subscriptionState.subscriptionDetails();
        const billing = subDetails?.subscriptions?.billing;
        const billingTerm = (billing?.term || (subDetails?.subscriptions?.billingCycle === 'yearly' ? TermUnit.YEAR : TermUnit.MONTH)) as TermUnit;
        return billingTerm ? oldPrice / termToMonthlyDivisor(billingTerm) : oldPrice;
    }

    getPlanChangeDiff(): number {
        const monthlyPrice = this.getRequestedPlanMonthlyPrice();
        const currentMonthlyPrice = this.getOldPlanMonthlyPrice();
        return monthlyPrice - currentMonthlyPrice;
    }

    isPlanChangeDowngrade(): boolean {
        const planId = this.selectedRequest?.metadata?.['planId'];
        const oldPlanId = this.selectedRequest?.metadata?.['oldPlanId'];
        const oldPlanName = this.selectedRequest?.metadata?.['oldPlanName'];

        const targetPlan = this.availablePlans.find(p => p._id === planId);
        const currentPlan = this.availablePlans.find(p => p._id === oldPlanId || p.name === oldPlanName) ?? null;

        if (currentPlan && targetPlan) {
            return isDowngradePlan(currentPlan, targetPlan);
        }
        return this.getPlanChangeDiff() <= 0;
    }

    confirmApprovePlanChangeRequest() {
        if (this.isApprovingPlanChange) return;
        this.isApprovingPlanChange = true;
        const isDowngrade = this.isPlanChangeDowngrade();
        const prorated = isDowngrade ? 0 : (this.proratedCharge ?? this.getProratedCharge());
        this.requestAccessService.approvePlanChange(this.selectedRequestId, prorated > 0 ? prorated : undefined).subscribe({
            next: (res) => {
                this.isApprovingPlanChange = false;
                if (res.success) {
                    const data = (res as any).data;
                    if (data?.checkoutUrl) {
                        this.approvePlanChangeDialogVisible = false;
                        window.location.href = data.checkoutUrl;
                    } else if (data?.scheduled) {
                        this.toast.success('Downgrade scheduled — will take effect from next billing cycle');
                        this.approvePlanChangeDialogVisible = false;
                        this.getAccessRequests();
                        this.loadUserPlanMap();
                    } else {
                        const credits = data?.proratedCredits;
                        if (credits && (credits.ask > 0 || credits.agent > 0)) {
                            const parts: string[] = [];
                            if (credits.ask > 0) parts.push(`${credits.ask} ask credits`);
                            if (credits.agent > 0) parts.push(`${credits.agent} agent credits`);
                            this.toast.success(`Plan change approved. ${parts.join(' and ')} added.`);
                        } else {
                            this.toast.success('Plan change approved successfully');
                        }
                        const approvedUserId = this.selectedRequest?.metadata?.['userId'];
                        const approvedPlanName = this.selectedRequest?.metadata?.['planName'];
                        if (approvedUserId && approvedPlanName) {
                            this.userPlanNames[approvedUserId] = approvedPlanName;
                        }
                        this.approvePlanChangeDialogVisible = false;
                        this.getAccessRequests();
                        this.getUsers();
                    }
                } else if ((res as any).data?.alreadyProcessed) {
                    this.handleAlreadyProcessedRequest((res as any).message);
                } else {
                    this.toast.error((res as any).message || 'Failed to approve plan change');
                }
            },
            error: (err: any) => {
                this.isApprovingPlanChange = false;
                if (err?.error?.data?.alreadyProcessed) {
                    this.handleAlreadyProcessedRequest(err.error.message);
                    return;
                }
                this.toast.error(err?.error?.message || 'Failed to approve plan change');
            }
        });
    }

    /** Request is no longer pending (approved/rejected elsewhere) — close the dialog and resync the list */
    private handleAlreadyProcessedRequest(message?: string) {
        this.approvePlanChangeDialogVisible = false;
        this.toast.info(message || 'This request was already processed');
        this.getAccessRequests();
        this.getUsers();
    }

    openCheckoutForUser(user: IUser) {
        if (this.isSalesPaymentMode) {
            this.handleContactSales();
            return;
        }
        this.bulkChangePlanUsers = [user];
        this.selectedUsersForCheckout = [user];
        this.selectedChangePlanId = '';
        this.showCheckoutDialog = true;
        this.loadOrgPlans();
    }

    openBulkChangePlan() {
        if (this.isSalesPaymentMode) {
            this.handleContactSales();
            return;
        }
        this.bulkChangePlanUsers = [...this.selectedUsers];
        this.selectedUsersForCheckout = [...this.selectedUsers];
        this.selectedChangePlanId = '';
        this.showCheckoutDialog = true;
        this.loadOrgPlans();
    }

    proceedToCheckout(config: CheckoutConfig) {
        this.selectedChangePlanId = config.planId;
        this.showCheckoutDialog = false;

        const billing = config.billing;
        const usersToProcess = config.userIds?.length
            ? config.userIds.map(id => this.allUsers.find(u => u._id === id)).filter(Boolean) as IUser[]
            : this.selectedUsersForCheckout;

        const plan = this.availablePlans.find(p => (p as any)._id === this.selectedChangePlanId);
        const users = usersToProcess.map(user => ({
            userId: user._id,
            userEmail: user.email,
            userName: user.fullName || `${user.firstName || ''} ${user.lastName || ''}`.trim()
        }));

        this.requestAccessService.requestPlanChange(
            this.selectedChangePlanId,
            plan?.name || '',
            users,
            billing.price,
            billing.term
        ).subscribe({
            next: (res) => {
                if (res.success) {
                    this.toast.success('Plan change request submitted successfully');
                    this.selectedChangePlanId = '';
                    this.getAccessRequests();
                } else {
                    this.toast.error((res as any).message || 'Failed to submit plan change request');
                }
            },
            error: (err: any) => {
                this.toast.error(err?.error?.message || 'Failed to submit plan change request');
            }
        });

        this.selectedUsers = [];
        this.selectedUsersForCheckout = [];
        this.bulkChangePlanUsers = [];
    }

    handleContactSales(): void {
        const planName = this.subscriptionState.plan()?.name ?? '';
        this.pendingSalesPlanName = planName;
        this.planService.sendUserDataToContactSales(planName).subscribe((res: any) => {
            if (res.code === 1004) {
                this.showPhoneNumberDialog = true;
            } else if (res.success) {
                this.toast.success('Request to sales sent successfully');
            }
        });
    }

    onPhoneNumberSubmitted(): void {
        this.handleContactSales();
    }

    loadOrgPlans() {
        this.isLoadingPlans = true;
        this.planService.getPlans().subscribe({
            next: (res) => {
                if (res.success) {
                    this.availablePlans = (res.data as IPlan[]).filter(plan =>
                        plan.pricing && plan.pricing.length > 0 &&
                        plan.pricing.some((p: any) => p.entity === EntityUnit.USER)
                    );
                }
                this.isLoadingPlans = false;
            },
            error: () => {
                this.isLoadingPlans = false;
                this.toast.error('Failed to load plans');
            }
        });
    }

    get orgDefaultPlan(): IPlan | null {
        return this.subscriptionState.orgSubscriptionDetails()?.plan as IPlan | null;
    }

    get orgDefaultPlanName(): string {
        return this.orgDefaultPlan?.name || 'Select Plan';
    }

    openPlanForMember(index: number) {
        this.currentMemberForCheckoutIndex = index;
        this.currentMemberEmails = [this.members[index].email];
        if (this.availablePlans.length > 0) {
            this.showInviteSingleCheckoutDialog = true;
        } else {
            this.isLoadingPlans = true;
            this.planService.getPlans().subscribe({
                next: (res) => {
                    if (res.success) {
                        this.availablePlans = (res.data as IPlan[]).filter(plan =>
                            plan.pricing && plan.pricing.length > 0 &&
                            plan.pricing.some((p: any) => p.entity === EntityUnit.USER)
                        );
                    }
                    this.isLoadingPlans = false;
                    this.showInviteSingleCheckoutDialog = true;
                },
                error: () => {
                    this.isLoadingPlans = false;
                    this.showInviteSingleCheckoutDialog = true;
                }
            });
        }
    }

    onSingleMemberPlanSelected(config: CheckoutConfig) {
        const index = this.currentMemberForCheckoutIndex;
        if (index >= 0 && index < this.members.length) {
            const plan = this.availablePlans.find(p => (p as any)._id === config.planId);
            this.members[index] = { ...this.members[index], planId: config.planId, planName: plan?.name || '' };
        }
        this.showInviteSingleCheckoutDialog = false;
    }

    openBulkInviteCheckout() {
        const remainingSlots = this.getRemainingInviteSlots();
        const membersCount = this.members.length;
        if (remainingSlots !== null) {
            if (remainingSlots === 0 || membersCount > remainingSlots) {
                this.toast.warn(`You can only invite ${remainingSlots} more ${remainingSlots === 1 ? 'person' : 'people'}. Please remove some members or wait for existing invites to be accepted.`);
                return;
            }
        }

        if (!this.hasBillingAccess) {
            this.requestBulkInviteForApproval();
            return;
        }

        if (this.isSalesPaymentMode) {
            this.sendMail();
            return;
        }
        const customerOptedFor = this.curretPlanMaxUsers;
        const existingInvitesCount = this.allInvites.length > 0 ? this.allInvites.length : this.activeInvitesCount;
        const totalAfterInvite = this.activeUsersCount + existingInvitesCount + membersCount;
        const orgPlanId = (this.orgDefaultPlan as any)?._id;
        const anyPlanChanged = this.members.some(m => m.planId && m.planId !== orgPlanId);
        
        if (customerOptedFor !== null && totalAfterInvite <= customerOptedFor && !anyPlanChanged) {
            this.sendMail();
            return;
        }

        this.bulkInviteEmails = this.members.map(m => m.email);
        this.bulkInviteMembers = this.members.map(m => ({ email: m.email, role: m.role, planId: m.planId, planName: m.planName }));
        this.selectedRequestId = '';
        this.showInviteBulkCheckoutDialog = true;
        this.loadOrgPlans();
    }

    requestBulkInviteForApproval() {
        const users = this.members.map(m => ({ email: m.email, role: m.role, planId: m.planId }));
        this.requestAccessService.requestPaymentForUserInvite(users).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.toast.success('Invite request submitted for approval');
                    this.inviteDialogVisible = false;
                    this.members = [];
                }
            },
            error: () => {
                this.toast.error('Failed to submit invite request. Please try again.');
            }
        });
    }

    acceptInvitePaymentRequest(request: IRequestAccess) {
        const raw: Array<{ email: string, role: string, planId?: string }> = JSON.parse(request.metadata?.['users'] || '[]');
        this.members = raw.map(u => ({ email: u.email, role: u.role as USER_ROLE, planId: u.planId }));
        this.bulkInviteEmails = this.members.map(u => u.email);
        this.bulkInviteMembers = this.members.map(u => ({ email: u.email, role: u.role, planId: u.planId }));
        this.selectedRequestId = request._id;
        this.loadOrgPlans();
        this.showInviteBulkCheckoutDialog = true;
    }

    proceedToInviteCheckout(_config: CheckoutConfig) {
        const requestId = this.selectedRequestId || undefined;
        const invitedCount = this.members.length;
        this.invitationService.sendInvite(this.members, USER_SOURCE.MAIL, requestId).subscribe({
            next: (res) => {
                // Close first: the checkout dialog's submit spinner only clears when the dialog is destroyed.
                this.closeInviteCheckout();
                if (!res.success) {
                    this.toast.error(res.message || 'Failed to send invitation');
                } else if (res.data?.requiresPayment) {
                    if (res.data.checkoutUrl) {
                        window.location.href = res.data.checkoutUrl;
                        return;
                    }
                    // e.g. trial user limit exceeded — the reason is on the payload, not the envelope.
                    this.toast.error(res.data.message || 'Payment required but checkout URL not found');
                } else {
                    this.activeInvitesCount += invitedCount;
                    this.toast.success('Invitation sent successfully');
                }
                this.allInvites = [];
                this.getInvites();
                this.getAccessRequests();
            },
            error: (err) => {
                this.closeInviteCheckout();
                this.toast.error(err?.error?.message || 'Failed to send invitation');
            }
        });
    }

    private closeInviteCheckout() {
        this.showInviteBulkCheckoutDialog = false;
        this.inviteDialogVisible = false;
        this.members = [];
        this.selectedRequestId = '';
    }


    rejectCreditRequest(requestId: string) {
        this.requestAccessService.removeRequest(requestId).subscribe({
            next: (res) => {
                if (res.success) {
                    this.toast.success('Credits request rejected successfully');
                    this.getAccessRequests();
                } else {
                    this.toast.error(res.message || 'Failed to reject credits request');
                }
            },
            error: (err) => {
                this.toast.error(err?.error?.message || 'Failed to reject credits request');
            }
        });
    }

    confirmRejectRequest() {
        // If it's a deactivation request, call revokeDeactivation instead
        if (this.selectedRequest?.requestType === REQUEST_TYPE.DEACTIVATION) {
            if (!this.selectedRequest?.email) {
                this.toast.error('User email not found');
                return;
            }

            this.rejectingDeactivation = true;
            this.requestAccessService.revokeDeactivation(this.selectedRequest.email).subscribe({
                next: (res) => {
                    if (res.success) {
                        this.toast.success('Deactivation revoked successfully');
                        this.rejectRequestDialogVisible = false;
                        this.getAccessRequests();
                    } else {
                        this.toast.error(res.message || 'Failed to revoke deactivation');
                    }
                    this.rejectingDeactivation = false;
                },
                error: (err) => {
                    this.toast.error(err?.message || 'Failed to revoke deactivation');
                    this.rejectingDeactivation = false;
                }
            });
        } else {
            // For creation and plan change requests, remove the request
            this.requestAccessService.removeRequest(this.selectedRequestId).subscribe((res) => {
                if (res.success) {
                    const msg = this.selectedRequest?.requestType === REQUEST_TYPE.PLAN_CHANGE
                        ? 'Plan change request rejected successfully'
                        : 'Request rejected successfully';
                    this.toast.success(msg);
                    if (this.selectedRequest?.requestType === REQUEST_TYPE.PLAN_CHANGE) {
                        const userId = this.selectedRequest.metadata?.['userId'];
                        if (userId) delete this.userPlanNames[userId];
                    }
                    this.allRequests = [];
                    this.getAccessRequests();
                    this.rejectRequestDialogVisible = false;
                }
            });
        }
    }

    resendInvite(invite: IInvitation) {
        if (this.currentUser.role !== USER_ROLE.SUPER_ADMIN && this.currentUser.role !== USER_ROLE.ADMIN) {
            this.toast.error('You are not authorized to resend this invite');
            return;
        }
        this.invitationService.resendInvite(this.currentUser._id, invite.role, invite.email, invite.organization as string).subscribe((res) => {
            if (res.success) {
                this.toast.success('Invite resent successfully');
                this.allInvites = [];
                this.getInvites();
            }
        });
    }

    onAzureDialogHide() {
        this.azurePeopleList.forEach(person => {
            person.selected = false;
        });
        this.azureDialogVisible = false;
        this.azurePeopleList = [];
        this.selectedAzurePeople = [];
        this.selectAllAzure = false;
        this.azureSearchValue = '';
        this.currentSearchQuery = '';
        this.totalAzureUsers = 0;
        this.azureNextLink = null;
        this.hasMoreAzureUsers = false;
        this.isLoadingSelectAllAzure = false;
        this.selectedAzurePeopleMap.clear();
    }


    getSelectedCreationRequests(): IRequestAccess[] {
        return this.selectedRequests.filter(req => req.requestType === REQUEST_TYPE.CREATION);
    }

    getSelectedDeactivationRequests(): IRequestAccess[] {
        return this.selectedRequests.filter(req => req.requestType === REQUEST_TYPE.DEACTIVATION);
    }

    getSelectedApproveCreationRequests(): IRequestAccess[] {
        return this.getSelectedCreationRequests().filter(req => req.status === 'REQUESTED');
    }

    getSelectedRejectCreationRequests(): IRequestAccess[] {
        return this.getSelectedCreationRequests().filter(req => req.status === 'REQUESTED');
    }

    getSelectedApproveDeactivationRequests(): IRequestAccess[] {
        return this.getSelectedDeactivationRequests().filter(req => req.status === 'REQUESTED');
    }

    getSelectedRejectDeactivationRequests(): IRequestAccess[] {
        return this.getSelectedDeactivationRequests().filter(req => req.status === 'REQUESTED');
    }

    /**
     * Check if a specific request belongs to the current logged-in user
     * @param request - The request to check
     * @returns true if the request belongs to the current user, false otherwise
     */
    isCurrentUserRequest(request: IRequestAccess): boolean {
        if (!this.currentUser?.email || !request?.email) {
            return false;
        }
        return request.email.toLowerCase() === this.currentUser.email.toLowerCase();
    }

    openBulkApproveCreationDialog() {
        const requests = this.getSelectedApproveCreationRequests();
        if (requests.length === 0) {
            this.toast.warn('Please select at least one creation request to approve');
            return;
        }
        this.bulkSelectedRequestIds = requests.map(r => r._id);
        this.bulkApproveCreationDialogVisible = true;
    }

    onRequestViewChange(view: REQUEST_VIEW) {
        this.requestView = view;
        const isHistory = view === REQUEST_VIEW.HISTORY;
        this.requestsTableColumns = [...REQUESTS_TABLE_COLUMNS(this.isAdmin, isHistory)];
        this.requestsTableConfig = {
            ...REQUESTS_TABLE_CONFIG(isHistory, this.hasBillingAccess),
            columnSortingFunction: (field: string, order: SORT_ORDER) => this.sortRequests(field, order),
        };
        this.getAccessRequests(view);
    }

    openBulkRejectCreationDialog() {
        const requests = this.getSelectedRejectCreationRequests();
        if (requests.length === 0) {
            this.toast.warn('Please select at least one creation request to reject');
            return;
        }
        this.bulkSelectedRequestIds = requests.map(r => r._id);
        this.bulkRejectCreationDialogVisible = true;
    }

    openBulkApproveDeactivationDialog() {
        const requests = this.getSelectedApproveDeactivationRequests();
        if (requests.length === 0) {
            this.toast.warn('Please select at least one deactivation request to approve');
            return;
        }
        this.bulkSelectedRequestIds = requests.map(r => r._id);
        this.bulkApproveDeactivationDialogVisible = true;
    }

    openBulkRejectDeactivationDialog() {
        const requests = this.getSelectedRejectDeactivationRequests();
        if (requests.length === 0) {
            this.toast.warn('Please select at least one deactivation request to reject');
            return;
        }
        this.bulkSelectedRequestIds = requests.map(r => r._id);
        this.bulkRejectDeactivationDialogVisible = true;
    }

    confirmBulkApproveCreation() {
        if (this.bulkSelectedRequestIds.length === 0) {
            return;
        }

        // Get the selected requests to extract role
        const selectedCreationRequests = this.allRequests.filter(r =>
            this.bulkSelectedRequestIds.includes(r._id) &&
            r.requestType === REQUEST_TYPE.CREATION
        );

        if (selectedCreationRequests.length === 0) {
            this.toast.error('No valid creation requests found');
            return;
        }

        // Group requests by role and process each group
        const requestsByRole = new Map<string, string[]>();
        selectedCreationRequests.forEach(request => {
            const role = request.role || USER_ROLE.MEMBER;
            if (!requestsByRole.has(role)) {
                requestsByRole.set(role, []);
            }
            requestsByRole.get(role)!.push(request._id);
        });

        // Process all role groups
        const approvePromises = Array.from(requestsByRole.entries()).map(([role, requestIds]) => {
            return this.requestAccessService.approveRequest({
                requestIds: requestIds,
                role: role
            }).toPromise();
        });

        Promise.all(approvePromises).then(results => {
            const paymentResult = results.find((r: any) => r?.success && r?.data?.requiresPayment && r?.data?.checkoutUrl);
            if (paymentResult) {
                this.bulkApproveCreationDialogVisible = false;
                this.resetSelectionState();
                window.location.href = (paymentResult as any).data.checkoutUrl;
                return;
            }

            const successCount = results.filter(r => r?.success).length;
            const totalRequestCount = this.bulkSelectedRequestIds.length;

            if (successCount === approvePromises.length) {
                this.toast.success(`${totalRequestCount} user creation request(s) approved successfully`);
            } else if (successCount > 0) {
                this.toast.warn(`Some requests could not be approved`);
            } else {
                this.toast.error('Failed to approve requests');
            }

            this.bulkApproveCreationDialogVisible = false;
            this.resetSelectionState();
            this.getAccessRequests();
        }).catch(error => {
            this.toast.error('Failed to approve some requests');
            this.bulkApproveCreationDialogVisible = false;
            this.resetSelectionState();
        });
    }

    confirmBulkRejectCreation() {
        if (this.bulkSelectedRequestIds.length === 0) {
            return;
        }

        // Process all requests
        const rejectPromises = this.bulkSelectedRequestIds.map(requestId => {
            return this.requestAccessService.removeRequest(requestId).toPromise();
        });

        Promise.all(rejectPromises).then(results => {
            const successCount = results.filter(r => r?.success).length;
            if (successCount > 0) {
                this.toast.success(`${successCount} user creation request(s) rejected successfully`);
            }
            if (successCount < this.bulkSelectedRequestIds.length) {
                this.toast.warn(`Some requests could not be rejected`);
            }
            this.bulkRejectCreationDialogVisible = false;
            this.resetSelectionState();
            this.getAccessRequests();
        }).catch(error => {
            this.toast.error('Failed to reject some requests');
            this.bulkRejectCreationDialogVisible = false;
            this.resetSelectionState();
        });
    }

    confirmBulkApproveDeactivation() {
        if (this.bulkSelectedRequestIds.length === 0) {
            return;
        }
        this.bulkApproveDeactivationDialogVisible = false;
        this.transferOwnershipDialogVisible = true;
    }

    confirmBulkRejectDeactivation() {
        if (this.bulkSelectedRequestIds.length === 0) {
            return;
        }

        // Get the selected deactivation requests
        const deactivationRequests = this.allRequests.filter(r =>
            this.bulkSelectedRequestIds.includes(r._id) &&
            r.requestType === REQUEST_TYPE.DEACTIVATION
        );

        // Process all deactivation rejections
        const rejectPromises = deactivationRequests.map(request => {
            if (!request.email) {
                return Promise.resolve({ success: false, message: 'User email not found' });
            }
            return this.requestAccessService.revokeDeactivation(request.email).toPromise();
        });

        Promise.all(rejectPromises).then(results => {
            const successCount = results.filter(r => r?.success).length;
            if (successCount > 0) {
                this.toast.success(`Deactivation request cancelled`);
            }
            if (successCount < this.bulkSelectedRequestIds.length) {
                this.toast.warn(`Some deactivation requests could not be cancelled`);
            }
            this.bulkRejectDeactivationDialogVisible = false;
            this.resetSelectionState();
            this.getAccessRequests();
        }).catch(error => {
            this.toast.error('Failed to cancel some deactivation requests');
            this.bulkRejectDeactivationDialogVisible = false;
            this.resetSelectionState();
        });
    }
}
